import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, BRAND } from "@/data/content";

export const FAQ = () => (
  <section id="faq" className="py-24 sm:py-32 bg-white border-y border-zinc-200" data-testid="faq">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-4">Questions</p>
          <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-ink leading-[1.05]">
            Everything you were afraid to ask.
          </h2>
          <p className="mt-6 text-zinc-500">Still unsure? Talk to an advisor at <a href={BRAND.phoneHref} className="text-forest font-semibold underline underline-offset-4 whitespace-nowrap">{BRAND.phone}</a>.</p>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-zinc-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-lg sm:text-xl font-semibold text-ink hover:text-forest py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-zinc-600 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FAQ;
